import Vue from 'vue';

// * PROGRESSBAR MIXIN
import progressBar_mixin from '@/modules/progressBar/progressBar_mixin.js';
Vue.use(progressBar_mixin);